<script>
  export let figura;
  export let num;
  export let first;
  export let last;
  export let onUp;
  export let onDown;
  export let onRemove;

  import { openDocument } from "../utils/openDocument";
</script>

<style>
  img.arrow {
    width: 10px;
    height: 10px;
    cursor: pointer;
  }

  td.options {
    text-align: right;
    width: 30px;
  }

  td.options img {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }

  td.arrows {
    text-align: center;
    width: 15px;
    text-align: left;
  }

  td.num {
    width: 5%;
    text-align: center;
  }

  td.img {
    width: 10%;
    text-align: center;
  }

  td.img img {
    width: 100px;
  }
</style>

<tr>
  {#if !first || !last}
    <td class="arrows">
      {#if !first}
        <img
          class="arrow"
          src="/images/revista/up.svg"
          alt="Up Icon"
          on:click={onUp} />
      {/if}
    </td>
    <td class="arrows">
      {#if !last}
        <img
          class="arrow"
          src="/images/revista/down.svg"
          alt="Down Icon"
          on:click={onDown} />
      {/if}
    </td>
  {/if}
  <td class="num">{num}</td>
  <td class="img">
    <a
      href="#"
      onclick="return false;"
      on:click={() => openDocument(figura.imagen)}>
      <img src={figura.imagen} alt="Imagen Figura" />
    </a>
  </td>
  <td>{figura.descripcion}</td>
  <td class="options">
    <a
      href="#"
      onclick="return false;"
      on:click={() => openDocument(figura.imagen)}>
      <img src="/images/revista/download.svg" alt="View Icon" />
    </a>
  </td>
  <td class="options">
    <img
      src="/images/revista/close.svg"
      alt="Remove Icon"
      on:click={onRemove} />
  </td>

</tr>
